// src/services/follows.js
// Canonical follow modeli: users/{uid}/following subcollection kullanılır.
// Kök /follows koleksiyonu kaldırıldı (Faz-4 Adım 10 — Claude direktifi).

import { db } from "../firebase";
import {
  collection,
  query,
  limit,
  getDocs,
} from "firebase/firestore";

const TTL_MS = 60_000;

let cacheUid: string | null = null;
let cacheUids: string[] = [];
let cacheExpiresAt = 0;

/**
 * Aktif kullanıcının takip ettiği kullanıcı uid’lerini döndürür.
 * - users/{uid}/following subcollection'ından okur (canonical kaynak).
 * - Sonuçlar 60 sn cache'lenir.
 */
export async function getFollowingUids(
  // Gövdenin ilk satırı `if (!viewerId) return []` — nullish MEŞRU girdi
  // (`FriendPickerModal` `currentUser.uid || currentUser.id` geçiyor).
  viewerId: string | null | undefined,
  opts: { force?: boolean } = {},
): Promise<string[]> {
  if (!viewerId) return [];
  const { force = false } = opts;
  const now = Date.now();

  // 🐞 BUGGIFY · i-takip-onbellegi-bayat — SÜRESİ DOLMUŞ ÖNBELLEĞİ SERVİS ET.
  // Taklit edilen GERÇEK arıza: TTL `Date.now()` ile ölçülüyor; istemci saati
  // ileri/geri kayarsa (kanonda kayıtlı sınıf) 60 sn'lik pencere fiilen
  // sonsuza uzayabilir — kullanıcı birini takip eder, akış hâlâ eski listeyi
  // görür. SINANAN ONARIM: `opts.force` bypass'ı — takip/bırak akışları
  // `force:true` ile çağırdığı için liste yine de tazelenmeli.
  // ⚙️ Üretimde derleme zamanı elenir (`false && …` → Terser bloğu siler).
  if (!force && (process.env.REACT_APP_BUGGIFY === "1" && window.__vwBuggify?.("i-takip-onbellegi-bayat") || (cacheUid === viewerId && cacheExpiresAt > now))
      && cacheUid === viewerId) {
    return cacheUids;
  }

  const set = new Set<string>();

  // Canonical: users/{uid}/following subcollection
  try {
    // 🐞 BUGGIFY · i-takip-listesi-okunamaz — OKUMAYI DÜŞÜR.
    // Taklit edilen GERÇEK arıza: `users/{uid}/following` okuması kesinti /
    // kota / rules reddiyle başarısız olur. SINANAN ONARIM bu dosyanın kendi
    // DENETİM FIX'idir: *"hatalı (boş) sonucu 60sn CACHE'LEME"* — yani hata
    // sonrası boş liste ÖNBELLEĞE YAZILMAMALI ve bir sonraki çağrı gerçekten
    // yeniden denemeli. O dal bugüne kadar dünyada HİÇ koşmadı.
    // ⚙️ Üretimde derleme zamanı elenir (`false && …` → Terser bloğu siler).
    if (process.env.REACT_APP_BUGGIFY === "1" && window.__vwBuggify?.("i-takip-listesi-okunamaz")) {
      throw new Error("vw-buggify: following read failed");
    }
    const base = collection(db, `users/${viewerId}/following`);
    const snap = await getDocs(query(base, limit(500)));
    snap.forEach((d) => {
      set.add(String(d.id));
    });
  } catch (e) {
    console.error("following (users/*/following) okunamadı:", e);
    // DENETİM FIX — hatalı (boş) sonucu 60sn CACHE'LEME: feed/harita
    // 1 dakika "kimseyi takip etmiyorsun" gibi davranıyordu.
    return Array.from(set);
  }

  const arr = Array.from(set);
  cacheUid = viewerId;
  cacheUids = arr;
  cacheExpiresAt = Date.now() + TTL_MS;

  return arr;
}

export default {
  getFollowingUids,
};
